<template>
  <iSpace
    :height="myHeight"
    :width="myWidth"
    :style-overrides="{
      backgroundColor: getOptionValue(BackgroundColor),
      hoverBackgroundColor: getOptionValue(BackgroundColor, BaseOption.$states.HOVER),
    }"
  />
</template>

<script>
import { StandardSpacerElementMixin } from
  "%/dynamic-component-editor/standard-elements/spacer-element/standard-spacer-element-mixin";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import BackgroundRepeat from "%/dynamic-component-editor/options/background-repeat";
import BackgroundPosition from "%/dynamic-component-editor/options/background-position";
import BackgroundSize from "%/dynamic-component-editor/options/background-size";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";

export default {
  name: "SpacerElement",
  mixins: [StandardSpacerElementMixin],
  options: [
    BackgroundColor,
  ],
  optionBundles: [
    AnimationEffectsOptions,
  ],
  data() {
    return {
      BaseOption,
      BackgroundRepeat,
      BackgroundPosition,
      BackgroundColor,
      BackgroundSize,
    };
  },
};
</script>

<style scoped lang="scss">
</style>
